export default function CTASection() {
  return (
    <section id="cta" className="py-28 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/16aa28bdf48638e6ca1ea1e9924b6297.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F1419] via-[#0A0E14]/85 to-[#0A0E14]" />
      </div>
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: "linear-gradient(rgba(0,217,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(0,217,255,0.4) 1px, transparent 1px)", backgroundSize: "80px 80px" }} />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <span className="text-[#00D9FF] text-xs font-semibold uppercase tracking-widest mb-6 block" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
          지금 바로 콘텐츠를 혁신하세요
        </span>
        <h2 className="text-5xl md:text-6xl font-bold text-white leading-[1.1] tracking-tight mb-6" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          방송 콘텐츠를
          <br />
          <span className="text-[#00D9FF]">완전 자동 숏폼 스튜디오</span>로
        </h2>
        <p className="text-gray-400 text-xl max-w-2xl mx-auto leading-relaxed mb-12" style={{ fontFamily: "'Inter', sans-serif" }}>
          케이블TV·종편·지상파 영상을 업로드하면 AI가 핵심 장면을 찾고, 편집하고, 배포까지 완성합니다.
          수동 편집을 멈추고, 방송의 가치를 숏폼으로 극대화하세요.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <button className="bg-[#00D9FF] hover:bg-[#00D9FF]/90 text-[#0A0E14] font-bold text-base px-10 py-4 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap">
            무료 체험 시작하기
          </button>
          <button className="flex items-center gap-2 border border-white/20 hover:border-[#00D9FF]/40 text-white text-base font-medium px-8 py-4 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-line text-[#00D9FF]" />
            </span>
            데모 예약하기
          </button>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500">
          {[
            { icon: "ri-shield-check-line", text: "SOC 2 타입 II 인증" },
            { icon: "ri-lock-line", text: "엔터프라이즈 보안" },
            { icon: "ri-customer-service-2-line", text: "24/7 지원" },
            { icon: "ri-global-line", text: "글로벌 CDN" },
          ].map((t) => (
            <span key={t.text} className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${t.icon} text-[#10B981] text-sm`} />
              </span>
              {t.text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
